import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import "./home.css"
import ApiService from '../../services/apiService';
import img from '../../Assets/images/17364797.png'
import { toast } from 'react-toastify';
import GameHeader from '../header/header';
const OptimizationPage = () => {
    let navigate = useNavigate();
    const [userData, setItems] = useState([]);
    const [rowData, setRowData] = useState([]);
    const apiService = new ApiService();
    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            fetchuserData(items)
        }
    }, []);
    const fetchuserData = async (items) => {
        try {
            const params = new URLSearchParams();
            params.append('id', items?.nameid);
            const res = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
            setItems(res?.data[0]);
            const Params = new URLSearchParams();
            Params.append('userId', res?.data[0]?.id);
            Params.append('gameLevel', res?.data[0]?.playedGames + 1);
            const GamRes = await apiService.getApiParamater('CHECK_BALANCE', `?${Params.toString()}`);
            let gmeres = GamRes?.data
            if (gmeres?.length > 0) {
                navigate(`/History`, { state: { gmeres } });
            }
            const gameParams = new URLSearchParams();
            gameParams.append('userId', res?.data[0]?.id);
            gameParams.append('gameRound', res?.data[0]?.playedGames + 1);
            const GameRes = await apiService.getApiParamater('GET_USER_GAME', `?${gameParams.toString()}`);
            setRowData(GameRes?.data[0]);
        } catch (error) {
            const params = new URLSearchParams();
            params.append('id', items?.nameid);
            const res = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
            const gameParams = new URLSearchParams();
            gameParams.append('userId', res?.data[0]?.id);
            gameParams.append('gameRound', res?.data[0]?.playedGames + 1);
            const GameRes = await apiService.getApiParamater('GET_USER_GAME', `?${gameParams.toString()}`);
            setRowData(GameRes?.data[0]);
            console.error("Error fetching  data:", error);
        }
    };


    const startcarrier = async () => {
        if (userData?.playedGames === userData?.totalGames) {
            toast.warning("Please Upgrade your level to play next game")
            return
        } else if (userData?.balance <= 0) {
            toast?.warning('Insufficient Balance Please go to recharge')
            navigate(`/Recharge`, { state: { userData, rowData } });
        } else {
            try {
                const gameParams = new URLSearchParams();
                gameParams.append('userId', userData?.id);
                gameParams.append('gameId', rowData?.id);
                gameParams.append('gameLevel', userData?.playedGames + 1);
                const GameRes = await apiService.getApiParamater('CHECK_BALANCE', `?${gameParams.toString()}`);
                let res = GameRes
                debugger
                if (res) {
                    debugger
                    toast.error("Please submit your pending game data to continue")
                    // navigate(`/Play`, { state: { userData, rowData } });
                }
            } catch (error) {
                if (error?.response?.data?.message === "No matching records found") {
                    let param = `?userId=${userData?.id}&gameId=${rowData?.id}&gameLevel=${userData?.playedGames + 1}`
                    const response = await apiService.PostApiParamater("PLAY_PERMISSION", param);
                    debugger
                    navigate(`/Play`, { state: { userData, rowData } });
                }
            }
        }
    };

    return (
        <div className="obtibg">
            <GameHeader />
            <div className='py-3'>
                <h5 className='bodhead center'>Data Optimized System</h5>
            </div>
            <div className="marquee-container">
                <div className="marquee-text">
                    Play Smart. Win Big. Work Online and Level Up Your Earnings
                </div>
            </div>
            <div className='p-lg-5'></div>
            <div className='optimizeBox mt-3 mt-lg-2 p-3 py-5 rounded shadow' style={{ backgroundColor: '#0a0f0d', color: '#fff' }}>
                {/* Title and Progress Count */}
                <div className='d-flex align-items-center'>
                    <img src={img} alt='Icon' style={{ width: '60px', marginRight: '10px' }} />
                    <div>
                        <div className='h5 fw-bold'>Optimization</div>
                        <div className='d-flex align-items-center mt-1'>
                            <div style={{ backgroundColor: '#0f0', width: '10px', height: '10px', borderRadius: '50%', marginRight: '6px' }}></div>
                            <div>{userData?.playedGames || 0}/{userData?.totalGames}</div>
                        </div>
                    </div>
                </div>
                {/* Progress Bar */}
                <div className="progress mt-3" style={{ height: '8px', backgroundColor: '#444' }}>
                    <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                            width: `${((userData?.playedGames || 0) / userData?.totalGames) * 100}%`,
                            backgroundColor: '#00ff00',
                        }}
                        aria-valuenow={(userData?.playedGames || 0)}
                        aria-valuemin="0"
                        aria-valuemax="50"
                    ></div>
                </div>
                {/* Stats */}
                <div className='d-flex justify-content-around mt-4'>
                    <div>
                        <div className=' boxtxt' style={{ fontSize: '14px' }}>Total Profit (USDC)</div>
                        <div className='fw-bold' style={{ fontSize: '20px' }}>{userData?.winningAmount || '0.00'}</div>
                    </div>
                    <div>
                        <div className=' boxtxt' style={{ fontSize: '14px' }}>Account Balance (USDC)</div>
                        <div className='fw-bold' style={{ fontSize: '20px' }}>{userData?.balance || '0.00'}</div>
                    </div>
                </div>
            </div>
            {userData?.status === true ?
                <div className='center p-3 pb-5 mb-4 '>
                    <button class="btn btn-scondary w-50 btn-lg " type="button" onClick={startcarrier}>
                        Generate
                    </button>
                </div> : ""}
        </div>
    );
};

export default OptimizationPage;
